(function () {
  "use strict";

  const STEP_ATTR = "data-hw-promo-step";
  const REGION_ATTR = "data-hw-promo-region";

  const controllerEl = document.querySelector("[data-hw-promo-controller]");
  if (!controllerEl) {
    console.error(
      "[pd-promo-controller] Missing [data-hw-promo-controller] element — controller will not run.",
    );
    return;
  }

  const campaignId = controllerEl.getAttribute("data-campaign-id");
  if (!campaignId) {
    console.error(
      "[pd-promo-controller] data-campaign-id is empty — controller will not run.",
    );
    return;
  }
  const SESSION_KEY = campaignId + "_session";
  const REGION_KEY = campaignId + "_region";

  const stepElements = document.querySelectorAll("[" + STEP_ATTR + "]");

  // ─── Session data (sessionStorage, no TTL) ───────────────────────────────────

  function getSession() {
    try {
      const raw = sessionStorage.getItem(SESSION_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function saveSession(updates) {
    try {
      sessionStorage.setItem(
        SESSION_KEY,
        JSON.stringify(Object.assign({}, getSession(), updates)),
      );
    } catch (e) {}
  }

  function clearSession() {
    sessionStorage.removeItem(SESSION_KEY);
  }

  // ─── Region data (localStorage, persists across sessions) ────────────────────

  function getSelectedRegion() {
    try {
      return localStorage.getItem(REGION_KEY) || null;
    } catch (e) {
      return null;
    }
  }

  function saveSelectedRegion(regionName) {
    try {
      if (regionName) {
        localStorage.setItem(REGION_KEY, regionName);
      } else {
        localStorage.removeItem(REGION_KEY);
      }
    } catch (e) {}
  }

  function clearSelectedRegion() {
    try {
      localStorage.removeItem(REGION_KEY);
    } catch (e) {}
  }

  // ─── Step guards ─────────────────────────────────────────────────────────────

  function guardStep(step) {
    const session = getSession();
    if (step === 3 && !session.formData) return 2;
    if (step === 2 && !getSelectedRegion()) return 1;
    return step;
  }

  // ─── Utilities ───────────────────────────────────────────────────────────────

  function parseStepFromHash(hash) {
    const match = hash.match(/^#step-(\d+)$/);
    return match ? parseInt(match[1], 10) : null;
  }

  function toStep(n) {
    return parseInt(n, 10) || 1;
  }

  // ─── DOM updates ─────────────────────────────────────────────────────────────

  function renderStep(stepNum) {
    if (window?.Shopify?.designMode) return;

    stepElements.forEach(function (el) {
      const stepAttr = el.getAttribute(STEP_ATTR);
      const steps = stepAttr.split(",").map(function (s) {
        return parseInt(s.trim(), 10);
      });

      if (steps.includes(stepNum)) {
        el.removeAttribute("hidden");
      } else {
        el.setAttribute("hidden", "");
      }
    });
  }

  // ─── Step navigation ─────────────────────────────────────────────────────────

  function applyStep(stepNum) {
    renderStep(stepNum);
    saveSession({ currentStep: stepNum });
  }

  // For non-user-initiated transitions (popstate, init): replaces history entry.
  function showStep(rawStep) {
    const stepNum = guardStep(toStep(rawStep));
    applyStep(stepNum);
    history.replaceState({ hwPromoStep: stepNum }, "", "#step-" + stepNum);
  }

  // For user-initiated transitions: pushes a new history entry.
  function goToStep(rawStep) {
    const stepNum = guardStep(toStep(rawStep));
    history.pushState({ hwPromoStep: stepNum }, "", "#step-" + stepNum);
    applyStep(stepNum);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  // ─── Initial step resolution ─────────────────────────────────────────────────

  function getInitialStep() {
    return (
      parseStepFromHash(window.location.hash) || getSession().currentStep || 1
    );
  }

  // ─── Sticky region selector ──────────────────────────────────────────────────
  // Note: --promo-sticky-top is managed by StickyHeader in header.liquid

  const regionSelector = document.querySelector(
    "[data-hw-promo-region-selector]",
  );
  const regionMenu = document.querySelector("[data-hw-promo-region-menu]");
  const regionText = document.querySelector("[data-hw-promo-region-text]");

  function updateSelectedRegion(regionName) {
    if (regionText) {
      regionText.textContent = regionName || "Select Region";
    }
    saveSelectedRegion(regionName);
    document.dispatchEvent(
      new CustomEvent("hw-promo:region-changed", {
        detail: { region: regionName },
      }),
    );
  }

  function toggleRegionMenu() {
    if (!regionSelector || !regionMenu) return;

    const isExpanded = regionSelector.getAttribute("aria-expanded") === "true";

    if (isExpanded) {
      regionSelector.setAttribute("aria-expanded", "false");
      regionMenu.setAttribute("hidden", "");
    } else {
      regionSelector.setAttribute("aria-expanded", "true");
      regionMenu.removeAttribute("hidden");
    }
  }

  function closeRegionMenu() {
    if (!regionSelector || !regionMenu) return;
    regionSelector.setAttribute("aria-expanded", "false");
    regionMenu.setAttribute("hidden", "");
  }

  if (regionSelector) {
    regionSelector.setAttribute("aria-expanded", "false");
    regionSelector.addEventListener("click", toggleRegionMenu);
  }

  document.addEventListener("click", function (e) {
    if (
      regionSelector &&
      regionMenu &&
      !e.target.closest("[data-hw-promo-region-selector]") &&
      !e.target.closest("[data-hw-promo-region-menu]")
    ) {
      closeRegionMenu();
    }
  });

  // ─── Event listeners ─────────────────────────────────────────────────────────

  document.addEventListener("click", function (e) {
    const regionCard = e.target.closest("[" + REGION_ATTR + "]");
    if (regionCard) {
      e.preventDefault();
      const regionName = regionCard.getAttribute(REGION_ATTR);
      updateSelectedRegion(regionName);
      closeRegionMenu();
      goToStep(2);
      return;
    }

    if (e.target.closest("[data-hw-promo-cta-clear]")) {
      clearSession();
      clearSelectedRegion();
    }
  });

  document.addEventListener("hw-promo:form-submitted", function (e) {
    saveSession({ formData: (e.detail && e.detail.formData) || {} });
    const currentStep = getSession().currentStep;
    if (currentStep !== 3) {
      goToStep(3);
    }
  });

  window.addEventListener("popstate", function (e) {
    const stepNum =
      (e.state && e.state.hwPromoStep) ||
      parseStepFromHash(window.location.hash) ||
      1;
    showStep(stepNum);
  });

  // ─── Initialize ──────────────────────────────────────────────────────────────
  showStep(getInitialStep());

  const savedRegion = getSelectedRegion();
  if (savedRegion) {
    updateSelectedRegion(savedRegion);
  }
})();
